@if (overlay(); as overlay) {
    <vn-betstation-dialog [headerTitle]="overlay.title" [content]="overlay.text" [headerClass]="getDialogClass()">
        <ng-container actions>
            @if (overlay.messages?.['closeButtonText']; as closeButtonText) {
                <button
                    class="btn w-100"
                    [ngClass]="overlay.validation?.['type']?.toLowerCase() === DialogType.Error ? 'btn-primary' : 'btn-secondary'"
                    (click)="close()">
                    {{ closeButtonText }}
                </button>
            }
        </ng-container>
    </vn-betstation-dialog>
}
